import SystemAPI from '@/apis/business/common/system-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    /**
     * Kiểm tra xem trường có sử dụng phân hệ hay không
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    checkLicenseForApp (context, param) {
      return new Promise((resolve, reject) => {
        SystemAPI.getAsync(`license-app/${param.orgID}/${param.appCode}`)
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Kiểm tra xem trường còn hạn sử dụng phân hệ hay không
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    checkLicenseExpireDate (context, param) {
      return new Promise((resolve, reject) => {
        SystemAPI.getAsync(`license-expire/${param.orgID}/${param.appCode}`)
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
